import * as actionTypes from './constants';
import axios from 'axios';

export const getWallet = () => (dispatch, getState) => {
  const { userId } = getState().account.user;
  dispatch({
    type: actionTypes.GET_WALLET_REQUEST
  });

  return axios
    .get(`/payment/wallet/user/${userId}`)
    .then(response =>
      dispatch({
        type: actionTypes.GET_WALLET_SUCCESS,
        wallet: response.data
      })
    )
    .catch(err =>
      dispatch({
        type: actionTypes.GET_WALLET_REJECT
      })
    );
};

export const deposit = paymentInfo => {
  return dispatch => {
    return axios
      .post('/payment/deposit', {
        ...paymentInfo,
        amount: parseInt(parseFloat(paymentInfo.amount) * 100)
      })
      .then(response => {
        window.location.replace(response.data);
      });
  };
};

export const getWalletHistory = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.GET_WALLET_HISTORY_REQUEST
    });
    return axios
      .get('/payment/wallet/history')
      .then(response =>
        dispatch({
          type: actionTypes.GET_WALLET_HISTORY_SUCCESS,
          history: response.data
        })
      )
      .catch(err => {
        dispatch({
          type: actionTypes.GET_WALLET_HISTORY_REJECT
        });
      });
  };
};



// WEBPACK FOOTER //
// ./src/wallet/actions.js